import {
  Flex, FormControl, Text
} from '@chakra-ui/react'
import { Checkbox, createTheme, Drawer, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, ThemeProvider } from '@mui/material'
import { useState } from 'react'
import { FaFilter } from 'react-icons/fa'
import { MdClose } from 'react-icons/md'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { DescricaoCargo, iNomeId } from '../../../../../interfaces'

export interface iFiltro {
  atuacao: string[]
  areas: string[]
  cargos: string[]
  hierarquia: string[]
  nomeCargo: string
}

interface iDrawProps {
  isOpen: boolean
  onClose: () => void
  onFilter: (filtro: iFiltro, isReset: boolean) => void
  cargos: DescricaoCargo[]
  areas: iNomeId[]
}

export const DrawerFiltro: React.FC<iDrawProps> = ({ isOpen, onClose, onFilter, areas, cargos }) => {
  const opcoesAtuacao = ['Administrativo', 'Produtivo']
  const opcoesHierarquia = [
    'Chefia',
    'Coordenação',
    'Direção',
    'Gerência',
    'Produtivo',
    'Super intendência',
    'Supervisão'
  ]
  const [Filtro, setFiltro] = useState<iFiltro>({
    areas: [],
    cargos: [],
    atuacao: [],
    hierarquia: [],
    nomeCargo: ''
  })

  const theme = createTheme({
    typography: {
      fontFamily: [
        'NotoSans',
        'NotoSansThai',
        'Arial',
        'Roboto',
        "'Helvetica Neue'",
        'sans-serif'
      ].join(',')
    },
    shape: {
      borderRadius: 15
    }
  })

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 48 * 4.5 + 8,
        width: 220
      }
    }
  }

  const handleChange = (value: any | any[], name: keyof typeof Filtro): void => {
    const lastValue = value[value.length - 1]
    const currentList = Filtro[name] as string[]

    const alreadySelected = currentList.includes(lastValue)
    const newList = alreadySelected
      ? currentList.filter(e => e !== lastValue)
      : [...currentList, lastValue]

    setFiltro({ ...Filtro, [name]: newList })
  }

  return (
    <ThemeProvider theme={theme}>
        <Drawer
            open={isOpen}
            anchor={'right'}
            onClose={onClose}
            role={'presentation'}
        >
            <Flex fontSize={'16px'} fontWeight={'600'} width={'100%'} justifyContent={'space-between'} padding={'.75rem 1rem'} borderBottom={'2px solid var(--c6)'}>
                <Text>Filtros</Text>
                <MdClose onClick={onClose} size={24} color={'var(--Red)'}/>
            </Flex>

            <Flex gap={'1rem'} flexDir={'column'} padding={'1.25rem 1rem'}>
                <Flex gap={'.75rem'}>
                    <FormControl>
                        <InputLabel id="demo-multiple-checkbox-label" style={{ fontSize: '.875rem', color: '#000', marginBottom: '.125rem' }}>Cargos</InputLabel>
                        <Select
                            labelId="demo-multiple-checkbox-label"
                            id="demo-multiple-checkbox"
                            multiple
                            value={cargos.filter(e => Filtro.cargos.some(a => a === e.id)).map(e => { return e.nomeCargo })}
                            onChange={(e) => handleChange(e.target.value, 'cargos')}
                            input={<OutlinedInput label="cargos" />}
                            renderValue={(selected) => selected.join(', ')}
                            MenuProps={MenuProps}
                            style={{ width: '20rem', fontSize: '.875rem', borderRadius: '.25rem' }}
                            size='small'
                            >
                            {cargos.map((cargo, i) => (
                                <MenuItem key={i} value={cargo.id}>
                                    <Checkbox sx={{ '& .MuiSvgIcon-root': { fontSize: 16 } }} checked={Filtro.cargos.some(e => e === cargo.id)} />
                                    <ListItemText primaryTypographyProps={{ fontSize: '0.875rem' }} primary={cargo.nomeCargo} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Flex>

                <Flex gap={'.75rem'}>
                    <FormControl style={{ width: '20rem', fontSize: '.875rem', borderRadius: '.25rem' }} size="small">
                    <InputLabel id="select-areas-label" style={{ fontSize: '.875rem', color: '#000', marginBottom: '.125rem' }}>Áreas</InputLabel>
                    <Select
                        labelId="select-areas-label"
                        id="select-areas"
                        multiple
                        value={Filtro.areas}
                        onChange={(e) => setFiltro({ ...Filtro, areas: e.target.value as string[] })}
                        input={<OutlinedInput label="Áreas" />}
                        renderValue={(selected) => areas.filter(a => selected.includes(a.id)).map(a => a.nome).join(', ')}
                        MenuProps={MenuProps}
                        style={{ width: '20rem', fontSize: '.875rem', borderRadius: '.25rem' }}
                        size='small'
                    >
                        {areas.map((area) => (
                        <MenuItem key={area.id} value={area.id}>
                            <Checkbox sx={{ '& .MuiSvgIcon-root': { fontSize: 16 } }} checked={Filtro.areas.includes(area.id)} />
                            <ListItemText primaryTypographyProps={{ fontSize: '0.875rem' }} primary={area.nome} />
                        </MenuItem>
                        ))}
                    </Select>
                    </FormControl>
                </Flex>

                <Flex gap={'.75rem'}>
                    <FormControl style={{ width: '20rem', fontSize: '.875rem', borderRadius: '.25rem' }} size="small">
                        <InputLabel id="select-atuacao-label" style={{ fontSize: '.875rem', color: '#000', marginBottom: '.125rem' }}>Atuação</InputLabel>
                        <Select
                            labelId="select-atuacao-label"
                            id="select-atuacao"
                            multiple
                            value={Filtro.atuacao}
                            onChange={(e) => setFiltro({ ...Filtro, atuacao: e.target.value as string[] })}
                            input={<OutlinedInput label="Atuação" />}
                            MenuProps={MenuProps}
                            renderValue={(selected) => selected.join(', ')}
                            style={{ width: '20rem', fontSize: '.875rem', borderRadius: '.25rem' }}
                            size='small'
                        >
                            {opcoesAtuacao.map((atuacao) => (
                            <MenuItem key={atuacao} value={atuacao}>
                                <Checkbox sx={{ '& .MuiSvgIcon-root': { fontSize: 16 } }} checked={Filtro.atuacao.includes(atuacao)} />
                                <ListItemText primaryTypographyProps={{ fontSize: '0.875rem' }} primary={atuacao} />
                            </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Flex>

                <Flex gap={'.75rem'}>
                    <FormControl style={{ width: '20rem', fontSize: '.875rem', borderRadius: '.25rem' }} size="small">
                    <InputLabel id="select-hierarquia-label" style={{ fontSize: '.875rem', color: '#000', marginBottom: '.125rem' }}>Hierarquia</InputLabel>
                    <Select
                        labelId="select-hierarquia-label"
                        id="select-hierarquia"
                        multiple
                        value={Filtro.hierarquia}
                        onChange={(e) => setFiltro({ ...Filtro, hierarquia: e.target.value as string[] })}
                        input={<OutlinedInput label="Hierarquia" />}
                        renderValue={(selected) => selected.join(', ')}
                        MenuProps={MenuProps}
                        style={{ width: '20rem', fontSize: '.875rem', borderRadius: '.25rem' }}
                        size='small'
                    >
                        {opcoesHierarquia.map((nivel) => (
                        <MenuItem key={nivel} value={nivel}>
                            <Checkbox sx={{ '& .MuiSvgIcon-root': { fontSize: 16 } }} checked={Filtro.hierarquia.includes(nivel)} />
                            <ListItemText primaryTypographyProps={{ fontSize: '0.875rem' }} primary={nivel} />
                        </MenuItem>
                        ))}
                    </Select>
                    </FormControl>
                </Flex>

                <Flex gap={'.5rem'} justifyContent={'end'}>
                    <ButtonCmp
                        VarColor='c6'
                        onClick={onClose}
                    >Cancelar
                    </ButtonCmp>
                    <ButtonCmp
                        VarColor='Rosa'
                        onClick={() => { onFilter({ areas: [], cargos: [], atuacao: [], hierarquia: [], nomeCargo: '' }, true); setFiltro({ areas: [], cargos: [], atuacao: [], hierarquia: [], nomeCargo: '' }) }}
                    >Restaurar filtros
                    </ButtonCmp>
                    <ButtonCmp
                        VarColor='Green2'
                        onClick={() => onFilter(Filtro, false)}
                        leftIcon={<FaFilter/>}
                    >Filtrar
                    </ButtonCmp>
                </Flex>
            </Flex>
        </Drawer>
    </ThemeProvider>
  )
}
